import HTTP from '../HTTP';

const URL_BASE = 'gescom/EcheancierLigne/';

export async function getDetailEcheancierLigne(id) {
  const response = await HTTP.get(URL_BASE + 'GetDetailEcheancierLigne', { params: { id } });
  return response;
}

export async function updateBaf(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateBafAsync', params);
  return response;
}
